const Loader = () => {
  return <div className="custom-loader"></div>;
};

export default Loader;
